<template>
	<div>
		<Teleport to="body">
			<div
				v-if="!includeToggle || showDialog"
				class="tooltip-container fade-in"
				:style="containerStyle"
			>
				<div class="tooltip-dialog">
					<div class="tooltip-content">
						<i class="tooltip-close-icon symbol close" />

						<header class="tooltip-header">
							<h6 class="tooltip-header-title">{{title}}</h6>

							<em v-if="description">{{description}}</em>
						</header>

						<slot></slot>
					</div>
				</div>
			</div>

			<div
				v-if="!includeToggle || showDialog"
				@click="dismiss"
				class="screen"
			></div>
		</Teleport>

		<div
			v-if="includeToggle"
			class="btn-help"
			ref="trigger"
			@click="openDialog"
		>
			<i class="symbol help toggle-icon">
				<object
					tabindex="-1"
					type="image/svg+xml"
					data="/static/build/gfx/svg/symbol-help.svg"
				/>

				<object
					class="help-hover"
					tabindex="-1"
					type="image/svg+xml"
					data="/static/build/gfx/svg/symbol-help-hover.svg"
				/>
			</i>

			<span v-if="toggleText" class="toggle-text">{{toggleText}}</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Tooltip',

	props: {
		handleDismiss: Function,
		description: String,
		title: String,
		toggleText: String,
		align: {
			type: String,
			default: 'right',
		},
		includeToggle: {
			type: Boolean,
			default: true,
		},
		topOffset: {
			type: String,
			default: '24px',
		},
	},

	data: () => ({
		showDialog: false,
		triggerRect: null,
	}),

	computed: {
		containerStyle () {
			const { triggerRect, align, topOffset } = this
			if (!triggerRect) return { position: 'absolute', zIndex: 9999 }

			const top = triggerRect.bottom + window.scrollY + parseInt(topOffset)

			if (align === 'left') {
				return {
					position: 'absolute',
					top: `${top}px`,
					left: `${triggerRect.right + window.scrollX - 472}px`,
					zIndex: 9999,
				}
			}
			return {
				position: 'absolute',
				top: `${top}px`,
				left: `${triggerRect.left + window.scrollX}px`,
				zIndex: 9999,
			}
		},
	},

	methods: {
		openDialog () {
			this.triggerRect = this.$refs.trigger.getBoundingClientRect()
			this.showDialog = true
		},

		dismiss () {
			const { handleDismiss } = this

			if (handleDismiss) handleDismiss()
			else this.showDialog = false
		},
	},
}
</script>

<style scoped>
.btn-help {
	display: flex;
	align-items: flex-start;
	cursor: pointer;
	flex-shrink: 0;
}

.toggle-icon {
	flex-shrink: 0;
}

.toggle-text {
	margin-left: 8px;
	color: #2EA3F2;
	font-weight: 600;
}

.tooltip-close-icon {
	position: absolute;
	top: 8px;
	right: 32px;
	width: auto;
	height: auto;
}

.tooltip-dialog {
	width: 472px;
	padding: 24px 36px;
	background-color: white;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.33);
	border-radius: 8px;
	font-size: 13px;
	white-space: normal;
}

.tooltip-content > :slotted(p) {
	line-height: 1.4;
	opacity: 1;
	font-weight: normal;
}

:slotted(p:last-of-type) {
	margin-bottom: 0px;
}

.tooltip-header {
	margin-bottom: 12px;
	padding-bottom: 12px;
	font-size: 13px;
	color: #4D4D4D;
	border-bottom: 1px solid #CCC;
	font-weight: normal;
}

.tooltip-header-title {
	margin-bottom: 4px;
}

.screen {
	position: fixed;
	z-index: 10000;
	height: 100vh;
	width: 100vw;
	top: 0px;
	left: 0px;
	cursor: pointer;
}
</style>
